export const calculateSplittedLunchServerTips = (shifts) => {
  let totalLunchNetSales = 0;
  let totalLunchSushiTips = 0;
  let totalLunchHostTips = 0;
  let totalLunchExpoTips = 0;
  let totalLunchCCTips = 0;
  let count = 0;
  for (let i = 0; i < shifts.length; i++) {
    if (shifts[i].IsLunch && shifts[i].Title === 'Server') {
      totalLunchNetSales = totalLunchNetSales + shifts[i].NetSales;
      totalLunchSushiTips = totalLunchSushiTips + shifts[i].SushiTip;
      totalLunchHostTips = totalLunchHostTips + shifts[i].HostTip;
      totalLunchExpoTips = totalLunchExpoTips + shifts[i].ExpoTip;
      totalLunchCCTips = totalLunchCCTips + shifts[i].CCTip;
      count++;
    }
  }
  const splittedNetSales = Number((totalLunchNetSales / count).toFixed(2));
  const splittedSushiTip = Number((totalLunchSushiTips / count).toFixed(2));
  const splittedHostTip = Number((totalLunchHostTips / count).toFixed(2));
  const splittedExpoTip = Number((totalLunchExpoTips / count).toFixed(2));
  const splittedCCTip = Number((totalLunchCCTips / count).toFixed(2));
  //const splittedCCTipFee = Number((splittedCCTip * 0.025).toFixed(2));
  const splittedCCTipFee = 0;
  const splittedFinalTipOut = Number(
    (
      splittedCCTip -
      splittedCCTipFee -
      splittedSushiTip -
      splittedHostTip -
      splittedExpoTip
    ).toFixed(2),
  );
  return shifts.map((item) => {
    if (item.IsLunch && item.Title === 'Server') {
      return {
        ...item,
        NetSales: splittedNetSales,
        SushiTip: splittedSushiTip,
        HostTip: splittedHostTip,
        ExpoTip: splittedExpoTip,
        CCTip: splittedCCTip,
        CCTipFee: splittedCCTipFee,
        FinalTipOut: splittedFinalTipOut,
      };
    }
    return item;
  });
};

export const calculateLunchShiftTips = (state, shift) => {
  if (shift.Title === 'Server') {
    if (shift.SushiTip === 0) {
      const sushiTip = Number(
        (
          (shift.Sushi * (state.restaurant.SushiPercentage * 0.01)) /
          shift.ServerRatio
        ).toFixed(2),
      );
      const hostTip = Number(
        (
          ((shift.Beer +
            shift.ByBottle +
            shift.Liquor +
            shift.MixedCocktails +
            shift.Sake +
            shift.Wine +
            shift.Food +
            shift.Sushi +
            shift.NABeverage) *
            (state.restaurant.HostPercentage * 0.01)) /
          shift.ServerRatio
        ).toFixed(2),
      );
      const expoTip = Number(
        (
          ((shift.Food + shift.Sushi) *
            (state.restaurant.LunchExpoPercentage * 0.01)) /
          shift.ServerRatio
        ).toFixed(2),
      );
      const ccTip = Number((shift.CCTip / shift.ServerRatio).toFixed(2));
      const ccTipFee = Number((shift.CCTipFee / shift.ServerRatio).toFixed(2));
      const finalTipOut = Number(
        (ccTip - sushiTip - hostTip - expoTip - ccTipFee).toFixed(2),
      );
      return {
        ...shift,
        CCTip: ccTip,
        SushiTip: sushiTip,
        HostTip: hostTip,
        ExpoTip: expoTip,
        CCTipFee: ccTipFee,
        FinalTipOut: finalTipOut,
      };
    } else {
      const SushiTip = Number((shift.SushiTip / shift.ServerRatio).toFixed(2));
      const ExpoTip = Number((shift.ExpoTip / shift.ServerRatio).toFixed(2));
      const HostTip = Number((shift.HostTip / shift.ServerRatio).toFixed(2));

      const CCTip = Number((shift.CCTip / shift.ServerRatio).toFixed(2));
      const CCTipFee = Number((shift.CCTipFee / shift.ServerRatio).toFixed(2));
      const NetSales = Number((shift.NetSales / shift.ServerRatio).toFixed(2));
      const finalTipOut = Number(
        (CCTip - SushiTip - ExpoTip - HostTip - CCTipFee).toFixed(2),
      );
      return {
        ...shift,
        NetSales,
        SushiTip,
        ExpoTip,
        HostTip,
        CCTip,
        CCTipFee,
        FinalTipOut: finalTipOut,
      };
    }
  } else if (shift.EmployeeID === 1) {
    const finalTipOut = Number((shift.CCTip - shift.CCTipFee).toFixed(2));
    return {
      ...shift,
      FinalTipOut: finalTipOut,
    };
  } else if (shift.Title === 'Host') {
    const numOfHost = state.shifts.filter(
      (i) => i.Title === 'Host' && i.IsLunch === true,
    ).length;
    const numOfExpo = state.shifts.filter(
      (i) => i.Title === 'Expo' && i.IsLunch === true,
    ).length;
    const numOfDailyHost = state.shifts.filter(
      (i) => i.Title === 'Host',
    ).length;
    const allDayHostTips = state.totalLunchHostTips + state.totalHostTips;
    if (shift.HostRatio === 1) {
      const finalTipOut = Number(
        (
          allDayHostTips / numOfDailyHost +
          state.totalLunchToGoTips / (numOfHost + numOfExpo)
        ).toFixed(2),
      );
      return {
        ...shift,
        FinalTipOut: finalTipOut,
      };
    } else {
      const finalTipOut = Number(
        (
          allDayHostTips * shift.HostRatio +
          state.totalLunchToGoTips / (numOfHost + numOfExpo)
        ).toFixed(2),
      );
      return {
        ...shift,
        FinalTipOut: finalTipOut,
      };
    }
  } else if (shift.Title === 'Expo') {
    const numOfHost = state.shifts.filter(
      (i) => i.Title === 'Host' && i.IsLunch === true,
    ).length;
    const numOfExpo = state.shifts.filter(
      (i) => i.Title === 'Expo' && i.IsLunch === true,
    ).length;
    const finalTipOut = Number(
      (
        state.totalLunchExpoTips / numOfExpo +
        state.totalLunchToGoTips / (numOfHost + numOfExpo)
      ).toFixed(2),
    );
    return {
      ...shift,
      FinalTipOut: finalTipOut,
    };
  }
  return shift;
};

export const calculateTotalLunchHostTips = (shifts) =>
  shifts.reduce((pre, current) => {
    if (
      current.IsLunch &&
      current.HostTip !== undefined &&
      current.HostTip !== 0
    ) {
      return pre + current.HostTip;
    } else {
      return pre;
    }
  }, 0);

export const calculateTotalLunchExpoTips = (shifts) =>
  shifts.reduce((pre, current) => {
    if (
      current.IsLunch &&
      current.ExpoTip !== undefined &&
      current.ExpoTip !== 0
    ) {
      return pre + current.ExpoTip;
    } else {
      return pre;
    }
  }, 0);

export const calculateTotalLunchToGoTips = (shifts) => {
  const togo = shifts.filter((i) => i.EmployeeID === 1 && i.IsLunch === true);
  if (togo.length === 0) return 0;
  else return togo[0].FinalTipOut;
};

export const calculateTotalLunchTipOut = (shifts) => {
  const lunchShifts = shifts.filter(
    (i) => i.IsLunch === true && i.EmployeeID !== 1,
  );
  if (lunchShifts.length === 0) return 0;
  else {
    const shiftsTipOut = lunchShifts.reduce((pre, current) => {
      return pre + current.FinalTipOut;
    }, 0);
    const sushiTipOut = lunchShifts.reduce((pre, current) => {
      if (current.SushiTip !== undefined && current.SushiTip !== 0) {
        return pre + current.SushiTip;
      } else {
        return pre;
      }
    }, 0);
    return shiftsTipOut + sushiTipOut;
  }
};

export const calculateLunchTipPool = (shifts) =>
  shifts
    .filter((i) => i.IsLunch === true)
    .reduce((pre, current) => {
      return pre + current.CCTip;
    }, 0);

export const validateLunchTipPool = (state) => {
  // Validating all tip out are calculated
  const lunchShifts = state.shifts.filter((i) => i.IsLunch === true);
  // if (lunchShifts.filter(i =>i.FinalTipOut === 0 || i.FinalTipOut === undefined).length > 0) {
  //   alert("Some shifts' tip out are not calculated!")
  //   return
  // }
  // Validating host tips assigned
  const hostShifts = state.shifts.filter(
    (i) => i.Title === 'Host' && i.IsLunch === true,
  );
  // if (hostShifts.length === 0) {
  //   alert('Could not perform tip pool validation');
  //   return;
  // }
  const expoShifts = state.shifts.filter(
    (i) => i.Title === 'Expo' && i.IsLunch === true,
  );

  const calculatedTotalHostTip = Number(
    hostShifts
      .reduce((pre, current) => {
        return pre + current.FinalTipOut;
      }, 0)
      .toFixed(2),
  );

  let calculatedTotalExpoTip = 0;
  if (expoShifts.length > 0) {
    calculatedTotalExpoTip = Number(
      expoShifts
        .reduce((pre, current) => {
          return pre + current.FinalTipOut;
        }, 0)
        .toFixed(2),
    );
  }
  // Validating total tip out

  const calculatedTotalSushiTipOut = Number(
    lunchShifts
      .reduce((pre, current) => {
        return pre + current.SushiTip;
      }, 0)
      .toFixed(2),
  );
  const calculatedTotalTipOut = Number(
    lunchShifts
      .reduce((pre, current) => {
        return pre + current.FinalTipOut;
      }, 0)
      .toFixed(2),
  );
  const totalLunchTipPool = Number(
    (state.totalLunchTipOut - calculatedTotalSushiTipOut).toFixed(2),
  );

  const totalHostExpoTipPool = Number(
    (state.totalLunchHostTips + state.totalLunchToGoTips).toFixed(2),
  );
  const calculatedHostExpoTipPool = Number(
    (calculatedTotalHostTip + calculatedTotalExpoTip).toFixed(2),
  );
  if (totalHostExpoTipPool - calculatedHostExpoTipPool > 0.02) {
    alert(
      "Total host tip out doesn't match! Total host tip pool: " +
        totalHostExpoTipPool +
        '; Total Host Tip Out: ' +
        calculatedHostExpoTipPool,
    );
  } else if (totalLunchTipPool - calculatedTotalTipOut > 0.02) {
    alert(
      "Total tip out doesn't match! Total tip out pool: " +
        totalLunchTipPool +
        '; Total Tip Out: ' +
        calculatedTotalTipOut,
    );
  } else {
    alert('Validation passed!');
  }
};
